import self from '@/common/utils/global-config';
import * as AppConfig from '@/common/utils/app-config';

/*
调取功能配置信息
key[string]：配置值
 */
export function getConfig(key) {
  if (['pcEntranceArea'].includes(key)) return AppConfig.getConfig()[key];
  const config = self.$sn.utils.getHospitalSessionStorage('HospitalConfigInformation');
  if (self.$sn.validate.empty(key) || self.$sn.validate.empty(config) || !self.$sn.validate.object(config)) return '';
  return config[key];
}
